// extracted by mini-css-extract-plugin
module.exports = {"container":"_2werrQdEdqyYyn8qNEhZPJ","icon":"_2S_zF0MVGrcxLHt1sYZHad"};